import { localizePath, parseLocalizedPathname } from "@plaatplan/i18n";
import { useNavigate, useLocation } from "react-router-dom";
import { LocaleFlag } from "./LocaleIcons.js";
import { useLocale } from "./useLocale.js";

function OptionButton({ active, label, leading, onPress }) {
  return (
    <button
      type="button"
      className={`locale-option${active ? " locale-option--active" : ""}`}
      aria-pressed={active}
      onClick={onPress}
    >
      {leading}
      <span>{label}</span>
    </button>
  );
}

export function LocaleSettingsPanel({ compact = false }) {
  const { display, preferences, setUnitSystem } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const switchLocale = (locale) => {
    const { path } = parseLocalizedPathname(location.pathname);
    navigate(localizePath(path, locale));
  };

  return (
    <div className={`locale-settings${compact ? " locale-settings--compact" : ""}`}>
      <div className="locale-settings-group">
        <span className="locale-settings-label">{display.t("web.settings.language")}</span>
        <div className="locale-settings-row">
          <OptionButton
            active={preferences.locale === "nl"}
            label={display.t("web.settings.languageNl")}
            leading={<LocaleFlag locale="nl" />}
            onPress={() => switchLocale("nl")}
          />
          <OptionButton
            active={preferences.locale === "en"}
            label={display.t("web.settings.languageEn")}
            leading={<LocaleFlag locale="en" />}
            onPress={() => switchLocale("en")}
          />
        </div>
      </div>
      {!compact ? (
        <div className="locale-settings-group">
          <span className="locale-settings-label">{display.t("web.settings.units")}</span>
          <div className="locale-settings-row">
            <OptionButton
              active={preferences.unitSystem === "metric"}
              label={display.t("web.settings.unitsMetric")}
              onPress={() => setUnitSystem("metric")}
            />
            <OptionButton
              active={preferences.unitSystem === "imperial"}
              label={display.t("web.settings.unitsImperial")}
              onPress={() => setUnitSystem("imperial")}
            />
          </div>
        </div>
      ) : (
        <div className="locale-settings-group">
          <div className="locale-settings-row">
            <OptionButton
              active={preferences.unitSystem === "metric"}
              label={display.t("web.settings.unitsMetric")}
              onPress={() => setUnitSystem("metric")}
            />
            <OptionButton
              active={preferences.unitSystem === "imperial"}
              label={display.t("web.settings.unitsImperial")}
              onPress={() => setUnitSystem("imperial")}
            />
          </div>
        </div>
      )}
    </div>
  );
}
